// extracted by mini-css-extract-plugin
export default {"container":"editable-data_container__f1vGG","content":"editable-data_content__ttCmD","field":"editable-data_field__VDKiy","buttons":"editable-data_buttons__McKJd"};